import { useEffect } from 'react';

export function useOutsideClickHandler(
	ref: any,
	setModalOpen: (isOpen: boolean) => void,
	setWarnModalOpen: (isOpen: boolean) => void,
	isChanged: boolean
) {
	useEffect(() => {
		function handleClickOutside(event: any) {
			if (ref.current && !ref.current.contains(event.target)) {
				if (isChanged) setWarnModalOpen(true);
				else setModalOpen(false);
			}
		}
		// Bind the event listener
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			// Unbind the event listener on clean up
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [ref, isChanged]);
}
